// TODO: cinema schedule API should JOIN cast/director/description from
// master catalogue so this frontend workaround can be removed.
// This util exists because /api/cinemas/:id/schedule joins the `movies`
// table on exact `vistaMovieId` (e.g. "1003HO00000566"), but movies only
// store one vistaMovieId per film — usually the "home" cinema's prefix.
// When a different cinema runs the same film under its own prefix
// (e.g. "1004HO00000566"), the schedule join misses and director/cast/
// description come back empty. We match by suffix of vistaMovieId so the
// frontend can fall back to the master catalogue.

export function buildMovieLookup(dbMovies) {
  const map = new Map();
  if (!Array.isArray(dbMovies)) return map;

  for (const m of dbMovies) {
    if (!m) continue;
    const id =
      m.vistaMovieId ?? m.vistamovieid ?? m.vistaMovieID ?? null;
    if (typeof id !== "string" || !id) continue;
    const suffix = id.split("HO")[1];
    if (suffix) map.set(suffix, m);
  }
  return map;
}

export function enrichScheduleMovies(scheduleMovies, dbMovies) {
  const lookup = buildMovieLookup(dbMovies);
  return (Array.isArray(scheduleMovies) ? scheduleMovies : []).map((m) => {
    if (!m) return m;

    const filmCode =
      typeof m.vistaMovieId === "string" ? m.vistaMovieId.split("HO")[1] : null;
    const dbMatch = filmCode ? lookup.get(filmCode) : null;

    const scheduleCast = Array.isArray(m.cast) ? m.cast : [];
    const scheduleDirector =
      typeof m.director === "string" ? m.director.trim() : "";
    const scheduleDescription =
      typeof m.description === "string" &&
      m.description.trim() &&
      m.description !== m.title
        ? m.description.trim()
        : "";

    const isValidString = (val) => {
      if (!val) return false;
      const v = String(val).toLowerCase().trim();
      return (
        v !== "duration tba" &&
        v !== "tba" &&
        v !== "nr" &&
        v !== "na" &&
        v !== ""
      );
    };

    return {
      ...m,

      poster: isValidString(m.poster)
        ? m.poster
        : dbMatch?.poster || dbMatch?.image || dbMatch?.banner || null,

      image: isValidString(m.image)
        ? m.image
        : dbMatch?.image || dbMatch?.poster || dbMatch?.banner || null,

      duration: isValidString(m.duration)
        ? m.duration
        : dbMatch?.duration || dbMatch?.runtime,

      ageRating: isValidString(m.ageRating)
        ? m.ageRating
        : isValidString(m.rating)
          ? m.rating
          : dbMatch?.ageRating || dbMatch?.rating,

      rating: isValidString(m.rating) ? m.rating : dbMatch?.rating,

      genre: isValidString(m.genre) ? m.genre : dbMatch?.genre,

      cast:
        scheduleCast.length > 0
          ? scheduleCast
          : Array.isArray(dbMatch?.cast)
            ? dbMatch.cast
            : typeof dbMatch?.cast === "string"
              ? dbMatch.cast
                  .split(",")
                  .map((s) => s.trim())
                  .filter(Boolean)
              : [],

      director: scheduleDirector || dbMatch?.director || "",

      description: scheduleDescription || dbMatch?.description || "",
    };
  });
}